module.exports = __webpack_public_path__ + "img/icon-notice.3f7ad479.png";